import { Observable, of } from 'rxjs'
import { CanvasService } from '../canvas.service'
import { CanvasArgs, CanvasBaseCommand, CanvasCommandType } from './canvas-command.model'

export interface ClearTraceArgs extends CanvasArgs {
  /** Client-side delegate that clears the active trace view. */
  action?: () => void
}

export class ClearTraceCommand extends CanvasBaseCommand<ClearTraceArgs> {
  readonly id = 'clear-trace'
  readonly type: CanvasCommandType = 'invoker'
  override icon = 'layers_clear'
  override label = 'Clear Trace'
  override tooltip = 'Clear trace'
  override readonly color = '#cf554d'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override enabled(args?: ClearTraceArgs): boolean {
    return !!args?.isTraceMode
  }

  protected doExecute(args?: ClearTraceArgs): Observable<boolean> {
    args?.action?.()
    return of(true)
  }
}
